import React from 'react';

import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormHelperText from '@material-ui/core/FormHelperText';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import ConfirmDialog from './ConfirmDialog';
import { getTerms } from './Terms';
import { getPrivacyPolicy } from './PrivacyPolicy';
import LockIcon from '@material-ui/icons/Lock';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import vippsPaymentImage from '../vipps-rgb-oransje-pos.png';
import netsPaymentImage from '../Nets_Logo_Pos_RGB.png';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20,
    display: 'flex',
};

const buttonIconStyle = {
    paddingRight: 10,
};

const buttonStyle = {
    width: 100,
    marginRight: 10,
    marginLeft: 10,
};

const termsButtonStyle = {
    width: '100%'
};

const helperTextStyle = {
    color: '#c7514c',
};

const vippsButtonStyle = {
    width: "68px",
    height: "auto",
    marginRight: "5px",
    marginLeft: "58px" 
};

const netsButtonStyle = {
    width: "60px",
    height: "auto",
    marginRight: "5px",
    marginLeft: "70px" 
};

const PrimaryRadio = withStyles({
    root: {
      color: "",
      '&$checked': {
        color: "#d97f33",
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

let t;
let self;

class ConfirmPurchaseDialog extends React.Component {
    constructor(props) {
        super(props);
        self = this;
        t = props.t;
        this.state = {
            open: props.open,
            termsChecked: false,
            privacyPolicyChecked: false,
            termsDialogOpen: false,
            privacyPolicyDialogOpen: false,
            paymentDialogOpen: false,
            activeVippsSubscriptionErrorDialogOpen: false,
            value: 'nets',
            showError: false,
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setValue = this.setValue.bind(this);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        // If NETS payment selected, check if gateway has vipps_agreement_id, if so, show error and return.
        if (self.props.selectedSubscription.vipps_agreement_id != '' && self.state.value === 'nets') {
            this.setState({
                activeVippsSubscriptionErrorDialogOpen: true
            });
            return;
        }

        // Close this dialog before closing the root dialog (which is done in onPaymentTypeSelected).
        this.setState({open: false})
        this.props.onPaymentTypeSelected(self.state.value, e);
    };

    setValue = (e) => {
        e.preventDefault();
        const value = e.target.value
        this.setState({value: value})
    };

    onBackClicked = e => {
        e.preventDefault();
        this.setState({
            paymentDialogOpen: false
        });
    }

    generatePrivacyPolicyDialog() {
        const privacyPolicyDialog =
            <ConfirmDialog
                titleText={t('privacy_policy')}
                messageText={getPrivacyPolicy(this.props.language)}
                buttonText={t('ok')}
                onButtonClicked={e => this.onPrivacyPolicyOkButtonClicked(e)}
                open={this.state.privacyPolicyDialogOpen} />
        return privacyPolicyDialog;
    }

    generatePaymentDialog() {
        //Check if screen size is small so Vipps and NETS images look ok.
        let smallScreen = false;
        if(window.screen.width <= 430){
            smallScreen = true;
        }

        // Check if customer is paying in EUR, if so we don't want to give them the Vipps payment option.
        let hideVippsOption = false;
        let currency  = "";
        if (this.props.selectedSubscription.fee != null) {
            currency = this.props.selectedSubscription.fee + '';
            if (currency.includes("EUR")) {
                hideVippsOption = true;
            }
        }

        const paymentDialog =
            <Dialog
                fullScreen={smallScreen}
                open={this.state.paymentDialogOpen}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{t('choose_payment_option')}</DialogTitle>
                <DialogContent >
                    <RadioGroup
                        defaultValue="nets"
                        name="payment-option"
                        value={self.state.value}
                        onChange={self.setValue}
                    > 
                    {hideVippsOption ? null : <FormControlLabel value="vipps" control={<PrimaryRadio/>} label={
                            <div>
                                {t('payment_label_vipps')}
                                <img src={vippsPaymentImage} style={vippsButtonStyle} />
                            </div>
                        } />
                    }
                    <FormControlLabel value="nets" control={<PrimaryRadio/>} label={
                            <div>
                                {t('payment_label_nets')}
                                <img src={netsPaymentImage} style={netsButtonStyle} />
                            </div>
                        } />
                    </RadioGroup>
                    <Typography>
                        {(self.state.value==="nets") ? t('confirm_purchase_message_1') : t('confirm_purchase_message_vipps_1')}
                        <br />
                        <br />
                        {(self.state.value==="nets") ? t('confirm_purchase_message_2') : t('confirm_purchase_message_vipps_2')}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="text"
                        color="default"
                        onClick={e => this.onBackClicked(e)}>
                        {t('back')}
                    </Button>
                    <Button
                        onClick={e => this.handleSubmit(e)}
                        variant="contained"
                        color="primary">
                        {t('next')}
                    </Button>
                </DialogActions>
            </Dialog>
        return paymentDialog;
    }

    generateTermsDialog() {
        const termsDialog =
            <ConfirmDialog
                titleText={t('subscription_terms')}
                messageText={getTerms(this.props.language)}
                buttonText={t('ok')}
                onButtonClicked={e => this.onTermsOkButtonClicked(e)}
                open={this.state.termsDialogOpen} />
        return termsDialog;
    }

    generateActiveVippsSubscriptionErrorDialog() {
        const activeVippsSubscriptionErrorDialog =
            <ConfirmDialog
                fullScreen={false}
                titleText={t('error_active_vipps_subscription_title')}
                messageText={t('error_active_vipps_subscription_message')}
                buttonText={t('ok')}
                onButtonClicked={e => this.onActiveVippsSubscriptionErrorButtonClicked(e)}
                open={this.state.activeVippsSubscriptionErrorDialogOpen} />
        return activeVippsSubscriptionErrorDialog;
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.checked
        });
    };

    handleClickOpen = () => {
        this.props.toggleDialog();
    };

    handleClose = () => {
        this.props.toggleDialog();
    };

    onAcceptClicked = e => {
        e.preventDefault();

        if (this.state.termsChecked && this.state.privacyPolicyChecked) {
            this.setState({
                paymentDialogOpen: true
            });
        } else {
            this.setState({
                showError: true
            });
        }
    }

    onDeclineClicked = e => {
        e.preventDefault();
        this.props.toggleDialog();
    }

    onTermsClicked = e => {
        e.preventDefault();
        this.setState({
            termsDialogOpen: true
        });
    }

    onTermsOkButtonClicked = e => {
        e.preventDefault();
        this.setState({
            termsDialogOpen: false
        });
    }

    onActiveVippsSubscriptionErrorButtonClicked = e => {
        e.preventDefault();
        this.setState({
            activeVippsSubscriptionErrorDialogOpen: false
        });
    }

    onPrivacyPolicyClicked = e => {
        e.preventDefault();
        this.setState({
            privacyPolicyDialogOpen: true
        });
    }

    onPrivacyPolicyOkButtonClicked = e => {
        e.preventDefault();
        this.setState({
            privacyPolicyDialogOpen: false
        });
    }

    render() {
        const { fullScreen } = this.props;

        // Todo: validateDOMNesting(...): <div> cannot appear as a descendant of <p>
        // Confirm dialog has Typography. getTerms() contains a div.




        return (
            <div>
                {this.state.termsDialogOpen ? this.generateTermsDialog() : null}
                {this.state.privacyPolicyDialogOpen ? this.generatePrivacyPolicyDialog() : null}
                {this.state.paymentDialogOpen ? this.generatePaymentDialog() : null}
                {this.state.activeVippsSubscriptionErrorDialogOpen ? this.generateActiveVippsSubscriptionErrorDialog(): null}
                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{t('confirm_purchase')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <b>{t('gateway_name')}: </b>{this.props.selectedSubscription.best_effort_name}
                            <br />
                            <b>{t('chosen_subscription')}: </b>{this.props.selectedSubscription.buy_description_short}
                            <br />
                            <b>{t('valid_to')}: </b>{this.props.selectedSubscription.valid_to_date}
                            <br />
                            <b>{t('price')}: </b>{this.props.selectedSubscription.fee}
                            <br />
                            <br />
                            <Button
                                autoFocus
                                style={termsButtonStyle}
                                variant="outlined"
                                color="secondary"
                                onClick={e => this.onPrivacyPolicyClicked(e)}>
                                <LockIcon style={buttonIconStyle} />
                                {t('show_privacy_policy')}
                            </Button >
                            <br />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.privacyPolicyChecked}
                                        onChange={this.handleChange('privacyPolicyChecked')}
                                        value="privacyPolicyChecked"
                                        color='secondary'
                                    />
                                }
                                label={t('i_have_read_the_privacy_policy')}
                            />
                            <br />
                            <br />
                            <Button
                                autoFocus
                                style={termsButtonStyle}
                                variant="outlined"
                                color="secondary"
                                onClick={e => this.onTermsClicked(e)}>
                                <HowToRegIcon style={buttonIconStyle} />
                                {t('show_terms')}
                            </Button >
                            <br />
                        </DialogContentText>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.termsChecked}
                                    onChange={this.handleChange('termsChecked')}
                                    value="termsChecked"
                                    color='secondary'
                                />
                            }
                            label={t('i_accept_the_terms')}
                        />
                        {this.state.showError ? <FormHelperText style={helperTextStyle}>{t('you_must_accept_the_terms')}</FormHelperText> : null}

                    </DialogContent>
                    <DialogActions>
                        <div style={buttonContainerStyle}>
                            <Button
                                style={buttonStyle}
                                variant="text"
                                color="default"
                                onClick={e => this.onDeclineClicked(e)}>
                                {t('decline')}
                            </Button >
                            <Button
                                autoFocus
                                style={buttonStyle}
                                variant="contained"
                                color="primary"
                                //Looks better with "disabled"-styling.
                                disabled={(!(this.state.termsChecked && this.state.privacyPolicyChecked))}
                                onClick={e => this.onAcceptClicked(e)}>
                                {t('accept')}
                            </Button >
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

ConfirmPurchaseDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};


export default withMobileDialog()(ConfirmPurchaseDialog);


// WEBPACK FOOTER //
// ./src/Components/ConfirmPurchaseDialog.js